<template>
  <div id="app">
    <transition name="overflow-fade">
      <div
        v-if="$root.ready && overflow"
        class="ready-overflow"
        @click="openWebsite()"
      >
        <div class="text-center w-100 content">
          <div class="title">The Wedding</div>
          <span>of</span>
          <div class="mb-5 name">
            {{ wedding.man.surname }}
            <span style="margin-top: -1rem; margin-bottom: -1rem;">&</span>
            {{ wedding.woman.surname }}
          </div>

          <button
            class="text-uppercase btn btn-outline-primary"
            @click="openWebsite()"
          >
            Buka Undangan
          </button>
        </div>
      </div>
    </transition>

    <AGWAudio
      :file="music.file"
      :loop="music.loop"
      :autoplay="music.autoplay"
      ref="audio"
    />
    <AGWHero
      overlay
      :images="backgrounds"
      ref="hero"
      parallax
      target="#intro"
    />

    <div
      class="bg-white agw-content"
      :style="{ 'margin-top': `${$root.hero.height}px` }"
    >
      <AGWIntro
        id="intro"
        style="position:relative; box-shadow: 0 5px 15px rgb(175 150 105 / 34%)"
      />

      <AGWPawiwahan id="pawiwahan" class="bg-blue-light py-5" />
      <AGWMepandes id="mepandes" class="pad-y-60" :mepandes="mepandes" />

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class="py-5" />
      <AGWMap
        :height="450"
        :url="map"
        :directionUrl="direction"
        :location="location"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <Himbauan />
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <FooterCeremonyku ref="footer" />

    <transition name="slide-fade">
      <guest-box :floating="true" />
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 =
  "https://ik.imagekit.io/crk/hendra-dekna/_DSC5056.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1664005015096&tr=w-700";
const ImageHero2 =
  "https://ik.imagekit.io/crk/hendra-dekna/_DSC5008.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1664005014940&tr=w-700";
const ImageHero3 =
  "https://ik.imagekit.io/crk/hendra-dekna/_DSC4961.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1664005013867&tr=w-700";

import Audio from "@/assets/audio/soundtrack.mp3";

import AGWHero from "@/components/Hero/HeroTwo";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery/GalleryOne";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";
import Himbauan from "./components/Himbauan.vue";
import FooterCeremonyku from "@/components/Footer/Ceremonyku";

const SESSION = [["2022-10-21 16:00", "Selesai"]];

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance,
    Himbauan,
    FooterCeremonyku
  },
  data() {
    return {
      title: "Wedding",
      backgrounds: [ImageHero1, ImageHero2, ImageHero3],
      bgActive: 0,
      dividerHeight: 0,
      overflow: true,
      location:
        "Desa Bengkel Banjar Kalibondan, Kec. Busungbiu, Kab. Buleleng - Bali",
      map:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3948.258555685962!2d115.02277431478137!3d-8.277044994044665!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x361d6c8826d20fb5!2zOMKwMTYnMzcuNCJTIDExNcKwMDEnMjkuOSJF!5e0!3m2!1sid!2sid!4v1664004675773!5m2!1sid!2sid",
      direction: "https://goo.gl/maps/TEp4bBYiAaBzUQ927",
      time: {
        start: this.$moment("2022-10-21 16:00"),
        end: "Selesai"
      },
      wedding: {
        man: {
          name: "Ketut Hendra Trisna Prayudi",
          surname: "Hendra",
          parents: "(Alm.) Made Suparto S.E. & Made Sri Ayu Martini ",
          description: "Putra ketiga",
          address: "Br. Dinas Bengkel, Kec. Busungbiu, Kab. Buleleng - Bali",
          photo:
            "https://ik.imagekit.io/crk/hendra-dekna/FOTO_SENDIRI_COWOK.JPG?updatedAt=1664005053187&tr=w-548,h-683,fo-custom,cm-extract"
        },
        woman: {
          name: "Ni Kadek Sucianna Widiastuti",
          surname: "Dek Na",
          parents: "I Putu Suastika & Yosefina Dahu Klau, S.Pd.SD",
          address:
            "Ds. Banjarasem, Dusun Kalanganyar, Kec. Seririt, Kab. Buleleng - Bali",
          description: "Putri kedua",
          photo:
            "https://ik.imagekit.io/crk/hendra-dekna/FOTO_CEWEK.JPG?updatedAt=1664005088844&tr=w-478,h-598,fo-custom,cm-extract"
        }
      },
      mepandes: [
        // {
        //   name: "I Made Wahyudika Adi Putra"
        //   // image: 'https://ik.imagekit.io/ceremonyku/iyan-tini/SKP_4414e_XA6Xqi5UR_LiP.jpg?tr=w-671,h-671,fo-custom,cm-extract'
        // },
        // {
        //   name: "I Nyoman Adi Ariawan"
        //   // image: 'https://ik.imagekit.io/ceremonyku/iyan-tini/SKP_4414e_XA6Xqi5UR_LiP.jpg?tr=w-671,h-671,fo-custom,cm-extract'
        // },
        // {
        //   name: "Ni Kadek Nadia Putri Arimbawa"
        //   // image: 'https://ik.imagekit.io/ceremonyku/iyan-tini/SKP_4414e_XA6Xqi5UR_LiP.jpg?tr=w-671,h-671,fo-custom,cm-extract'
        // },
        // {
        //   name: "I Putu Arya Megadhana"
        //   // image: 'https://ik.imagekit.io/ceremonyku/iyan-tini/SKP_4414e_XA6Xqi5UR_LiP.jpg?tr=w-671,h-671,fo-custom,cm-extract'
        // }
      ],
      gallery: [],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    },
    session() {
      const url = new URLSearchParams(window.location.search);
      const sesi = Number(url.get("sesi")) || 1;
      return sesi > SESSION.length ? 1 : sesi;
    }
  },
  mounted() {
    const [start, end] = SESSION[this.session - 1] || SESSION[0];

    this.time.start = this.$moment(start);
    this.time.end = end;

    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.sw.refreshing) return;
        this.sw.refreshing = true;
        window.location.reload();
      });
    }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
    },
    openWebsite() {
      this.overflow = false;
      document.querySelector("#loading").classList.remove("active");
      if (this.$refs.audio) this.$refs.audio.play();
    }
  }
};
</script>

<style lang="scss" scoped>
.overflow-fade-enter-active {
  transition: all 1s ease;
}
.overflow-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.overflow-fade-enter,
.overflow-fade-leave-to {
  opacity: 0;
}
</style>
